import { render, staticRenderFns } from "./Endossos.vue?vue&type=template&id=33259d8a"
import script from "./Endossos.vue?vue&type=script&lang=js"
export * from "./Endossos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports